import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    host: {
        '[class]': 'size()',
        role: 'status',
    },
    imports: [TranslatePipe],
})
export class LoaderComponent {
    readonly size = input<'xsmall' | 'small' | 'large'>('large');
}
